import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import React from "react";

interface RequiresDesignatedCaregiverDialogProps {
  open: boolean;
  onClose: () => void;
}

export const RequiresDesignatedCaregiverDialog: React.FC<RequiresDesignatedCaregiverDialogProps> = ({
  open,
  onClose,
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      aria-labelledby="designated-caregiver-required"
    >
      <DialogContent sx={{ zIndex: 2010 }}>
        <Alert severity="error" sx={{ marginBottom: "24px" }}>
          <AlertTitle id="designated-caregiver-required">
            The client requires a designated caregiver
          </AlertTitle>
          Removing this team member as designated caregiver would leave the client without a
          designated caregiver. Assigning a new designated caregiver will remove this team member as
          the current designated caregiver.
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
